function structure_to_source_type_map (structure) {
  let types = {}

  if (structure['fields'] && typeof structure['fields'].length !== 'undefined') {
    for (let field of structure['fields']) {
      let ret = structure_to_source_type_map(field)
      for (let k in ret) {
        types[k] = ret[k]
      }
    }
  }
  else {
    types[structure['source']['key']] = structure['source']['data_type']
  }
  return types
}

function structure_to_edit_type_map (structure) {
  let types = {}

  if (structure['fields'] && typeof structure['fields'].length !== 'undefined') {
    for (let field of structure['fields']) {
      let ret = structure_to_edit_type_map(field)
      for (let k in ret) {
        types[k] = ret[k]
      }
    }
  }
  else {
    types[structure['source']['key']] = structure['change']['type']
  }
  
  return types
}

export default {
  structure_to_edit_type_map,
  structure_to_source_type_map,
}